import { render, staticRenderFns } from "./compTopUpList.vue?vue&type=template&id=0a0110f5&scoped=true&"
import script from "./compTopUpList.vue?vue&type=script&lang=js&"
export * from "./compTopUpList.vue?vue&type=script&lang=js&"
import style0 from "./compTopUpList.vue?vue&type=style&index=0&id=0a0110f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0110f5",
  null
  
)

export default component.exports